export default "__VITE_ASSET__DIFu1o3d__"